export default __webpack_public_path__ + "static/media/web.92cc1b21.config";